import { useQuery } from '@tanstack/react-query'

import { getFreeePartners } from '@src/api'
import { DefaultApiGetFreeePartnersRequest } from '@src/api/generated/user-api'
import { REACT_QUERY_CACHE_KEYS } from '@src/consts'
import { useAxios } from '@src/hooks'

export const useFetchFreeePartners = (
  params: DefaultApiGetFreeePartnersRequest
) => {
  const { axiosInstance } = useAxios()
  const { data, isError, isLoading } = useQuery({
    enabled: !!params.organizationId && !!params.companyId,
    queryFn: () => getFreeePartners(axiosInstance, params),
    queryKey: [REACT_QUERY_CACHE_KEYS.GET_FREEE_PARTNERS],
  })

  return { data, isError, isLoading }
}
